/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Bald_Parakeet_ImagineInputs */

const fr_dull_bald_parakeet_imagine = /** @type {(inputs: Dull_Bald_Parakeet_ImagineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pack affilié`)
};

/**

* @param {Dull_Bald_Parakeet_ImagineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dull_bald_parakeet_imagine = /** @type {((inputs?: Dull_Bald_Parakeet_ImagineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Bald_Parakeet_ImagineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dull_bald_parakeet_imagine(inputs)
});